module.exports = __webpack_public_path__ + "0c4f367c6458983fd1ea4d2ef2f351b2.svg";